// extracted by mini-css-extract-plugin
export default {"piechart":"lTMcG","slice":"rO5Kg","tooltip":"kvOOb","hidden":"moohs"};